import React from 'react';
import './Footer.css'; // Make sure to create this CSS file
import logo from '../static/assets/logo.png'; // Adjust the path to your logo as necessary

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="logo-container-footer">
          <a href="/" className="logo-link">
            <img alt="Logo" src={logo} className="logo-img-footer" />
          </a>
        </div>
        {/* <div className="footer-block">
          <p>&copy; {new Date().getFullYear()} Escudero Electrical Contractors. All rights reserved.</p>
          <div className="footer-links">
            <a href="/about">About</a>
            <a href="/services">Services</a>
            <a href="/gallery">Gallery</a>
            <a href="/contact">Contact</a>
          </div>
        </div> */}
        <div className="map-container">
          <iframe
            title="Escudero Electrical Contractors - Google Maps"
            src="https://www.google.com/maps?q=Escudero+Electrical+Contractors+LLC+Chicago+IL&output=embed"
            width="100%"
            height="250"
            style={{ border: 0, borderRadius: '12px' }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
        <div className="content-container">
          <div className="areas-served-container">
            <h3>Areas We Serve</h3>
            <ul className="areas-served-grid">
              <li>Naperville, IL</li>
              <li>Bolingbrook, IL</li>
              <li>Hinsdale, IL</li>
              <li>Palos Hills, IL</li>
              <li>Schaumburg, IL</li>
              <li>Plainfield, IL</li>
            </ul>
              <p className="areas-served-fallback" style={{ marginTop: '12px', fontStyle: 'italic' }}>
                Don't see your city? Give us a call!
              </p>
          </div>
        </div>
        
      </div>
      <div className="footer-block">
          <p>&copy; {new Date().getFullYear()} Escudero Electrical Contractors LLC. All rights reserved.</p>
          <div className="footer-links">
            <a href="/about">About</a>
            <a href="/services">Services</a>
            <a href="/social-media">Social Media</a>
            <a href="/contact">Contact Us</a>
          </div>
        </div>
    </footer>
  );
};

export default Footer;
